import { render, staticRenderFns } from "./trend-up.vue?vue&type=template&id=38425ea4&"
import script from "./trend-up.vue?vue&type=script&lang=js&"
export * from "./trend-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports